import * as React from 'react';

function NotAuthorized() {
  return (
    <span>Not Authorized</span>
  );
}

export default NotAuthorized;
